var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 0.375C5.20312 0.375 0 5.57812 0 12C0 18.4219 5.20312 23.625 11.625 23.625C18.0469 23.625 23.25 18.4219 23.25 12C23.25 5.57812 18.0469 0.375 11.625 0.375ZM17.625 20.1562C15.9375 21.4219 13.8281 22.125 11.625 22.125C9.375 22.125 7.26562 21.4219 5.625 20.1562V19.5C5.625 17.8594 6.9375 16.5 8.625 16.5C9.14062 16.5 9.89062 17.0625 11.625 17.0625C13.3125 17.0625 14.0625 16.5 14.625 16.5C16.2656 16.5 17.625 17.8594 17.625 19.5V20.1562ZM19.0312 18.8906C18.7031 16.6875 16.875 15 14.625 15C13.6406 15 13.1719 15.5625 11.625 15.5625C10.0312 15.5625 9.5625 15 8.625 15C6.32812 15 4.5 16.6875 4.17188 18.8906C2.48438 17.0625 1.5 14.6719 1.5 12C1.5 6.42188 6 1.875 11.625 1.875C17.2031 1.875 21.75 6.42188 21.75 12C21.75 14.6719 20.7188 17.0625 19.0312 18.8906ZM11.625 5.625C9.32812 5.625 7.5 7.5 7.5 9.75C7.5 12.0469 9.32812 13.875 11.625 13.875C13.875 13.875 15.75 12.0469 15.75 9.75C15.75 7.5 13.875 5.625 11.625 5.625ZM11.625 12.375C10.1719 12.375 9 11.2031 9 9.75C9 8.34375 10.1719 7.125 11.625 7.125C13.0312 7.125 14.25 8.34375 14.25 9.75C14.25 11.2031 13.0312 12.375 11.625 12.375Z",
    fill: "#00C8D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9fa928bb5e1586169b54acdfd205a31b.svg";
export { ForwardRef as ReactComponent };